<template>
    <Dropdown class="me-1 mb-1" :color="dropdownColor" :title="title" small>
        <div class="px-3 py-2">
            <div class="text-xs text-muted">{{ $t('dateRange.from') }}</div>
            <Input
                v-model="start"
                :type="type"
                :placeholder="$t('dateRange.from')"
                @input="setFromDate"
                small
                class="mb-2"
            />
            <div class="text-xs text-muted">{{ $t('dateRange.to') }}</div>
            <Input v-model="end" :type="type" :placeholder="$t('dateRange.to')" @input="setToDate" small />
        </div>
    </Dropdown>
</template>

<script>
    import Input from './Input'
    import Dropdown from '../Dropdown'
    import moment from 'moment'

    export default {
        components: {
            Input,
            Dropdown,
        },
        props: {
            time: Boolean,
            label: String,
            value: Object,
        },
        emits: ['input', 'setFromDate', 'setToDate'],
        methods: {
            /**
             *
             * @deprecated
             * use v-model instead
             */
            setFromDate(val) {
                let from = moment(val).format(this.format)
                this.$emit('setFromDate', from)
            },
            /**
             *
             * @deprecated
             * use v-model instead
             */
            setToDate(val) {
                let to = moment(val).format(this.format)
                this.$emit('setToDate', to)
            },
        },
        computed: {
            format() {
                return this.time ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
            },
            type() {
                return this.time ? 'datetime-local' : 'date'
            },
            title() {
                return this.label || this.$t('dateRange.filter_date')
            },
            hasDate() {
                return Boolean(this.value?.start || this.value?.end)
            },
            start: {
                get() {
                    return this.value?.start || ''
                },
                set(newStart) {
                    const value = this.value || {}
                    const startDate = moment(newStart)
                    const start = startDate.isValid() ? startDate.format(this.format) : ''
                    this.$emit('input', {
                        ...value,
                        start,
                    })
                },
            },
            end: {
                get() {
                    return this.value?.end || ''
                },
                set(newEnd) {
                    const value = this.value || {}
                    const endDate = moment(newEnd)
                    const end = endDate.isValid() ? endDate.format(this.format) : ''
                    this.$emit('input', {
                        ...value,
                        end,
                    })
                },
            },
            dropdownColor() {
                return this.hasDate ? 'success' : 'secondary'
            },
        },
    }
</script>
